<div
  class="row px-3 py-1"
  [class.wide]="browseGroups?.length > 6"
  (mouseenter)="getPromotions()"
  >
  @for (productGroup of browseGroups; track productGroup) {
    @if (productGroup.sub_items?.length) {
      <div class="col-4 mb-3" [class.col-lg-3]="browseGroups?.length > 6">
        <h5
          class="mt-0 clickable withOpacity"
          (click)="selectGroup(productGroup.name)"
          >
          {{ productGroup.description }}
        </h5>
        <ul
          class="list-unstyled"
          [class.longlist]="productGroup.sub_items?.length > 5"
          >
          @for (articleGroup of productGroup.sub_items; track articleGroup) {
            <li
              class="text-white clickable withOpacity pe-1"
              (click)="selectGroup(productGroup.name, articleGroup.name)"
              >
              {{ articleGroup.description }}
            </li>
          }
        </ul>
      </div>
    }
  }
  <div class="col-4 mb-3">
    <h5>{{ "PROMOTIONS" | translate }}</h5>
    @if (promotions && !promotions.length && !promotionsLoaded) {
      <button class="px-3 py-1 dropdown-item btn">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    }
    @if (promotions && promotions.length) {
      <ul class="list-unstyled">
        @for (groupedPromotions of promotions; track groupedPromotions) {
          @for (promotion of groupedPromotions; track promotion) {
            <li
              class="text-white clickable withOpacity"
          (click)="
            gotoSearchPage(
              'CMN_PROM&HOMEPROMO=' +
                promotion.promotioncode +
                '&COMPANY=' +
                +promotion.company_id,
              $event
            )
          "
          [innerHTML]="
            promotion.title === '' ? promotion.promotioncode : promotion.title
          "
            ></li>
          }
        }
        @if (promotionsLoaded) {
          <li
            class="text-white clickable withOpacity"
            (click)="gotoSearchPage('CMN_PROM', $event)"
            >
            {{ "VIEW_ALL" | translate }}
          </li>
        }
      </ul>
    }
  </div>
</div>
